import { CheckboxGroupButtons } from '@/components/_common';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import {
  QuestCostDateFilter,
  QuestCostFormValues,
  QuestCostReportType,
  QuestCostSituationType,
  QuestCostWorkOrderTypes,
} from '@/core/domain/questReport/Reports/Cost/Cost.types';
import { isAppPortocar } from '@/index';
import { Form, FormInstance, Radio, Typography } from 'antd';
import { useIntl } from 'react-intl';

interface Props {
  form: FormInstance<QuestCostFormValues>;
}

export default function ManagerialCostForm({ form }: Props) {
  const intl = useIntl().formatMessage;
  const option = (message: string) => intl({ id: `cost.option.${message}` });
  const { costPerPartSales, fixedCost, overallCost, variableCost } =
    QuestCostReportType;
  const {
    workOrder,
    warranty,
    return: retorno,
    courtesy,
    totalLoss,
    revision,
  } = QuestCostWorkOrderTypes;

  const { open, liquidated } = QuestCostSituationType;

  const { emissionDate, dueDate, payDate } = QuestCostDateFilter;
  const { Title } = Typography;

  const reportTypeOptions = [
    { value: costPerPartSales, label: option('costXSale') },
    { value: fixedCost, label: option('fixedCost') },
    { value: variableCost, label: option('variableCost') },
    { value: overallCost, label: option('generalCost') },
  ];

  const budgetTypeOptions = [
    { value: workOrder, label: option('budget') },
    { value: warranty, label: option('warranty') },
    { value: retorno, label: option('return') },
    {
      value: courtesy,
      label: option(isAppPortocar ? 'insideCourtesy' : 'courtesy'),
    },
    { value: totalLoss, label: option('totalLoss') },
    { value: revision, label: option('revision') },
  ];

  const situationOptions = [
    { value: open, label: option('open') },
    { value: liquidated, label: option('liquidated') },
  ];

  const filterByDateOptions = [
    { value: emissionDate, label: option('emission') },
    { value: dueDate, label: option('dueDate') },
    { value: payDate, label: option('payment') },
  ];

  return (
    <Form layout="vertical" form={form}>
      <ReportSelectMonthFields form={form} />

      <Form.Item
        name="reportType"
        style={{ margin: '4px 0' }}
        label={
          <Title level={5} style={{ margin: '0' }}>
            {intl({ id: 'cost.label.reportType' })}
          </Title>
        }
        initialValue={costPerPartSales}
      >
        <Radio.Group
          buttonStyle="solid"
          optionType="button"
          size="large"
          options={reportTypeOptions}
        />
      </Form.Item>

      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const reportType = getFieldValue('reportType');

          if (reportType !== costPerPartSales) {
            return (
              <>
                <Form.Item
                  name="situation"
                  label={
                    <Title level={5} style={{ margin: '0' }}>
                      {intl({ id: 'cost.label.status' })}
                    </Title>
                  }
                  initialValue={[open]}
                >
                  <CheckboxGroupButtons options={situationOptions} />
                </Form.Item>

                <Form.Item
                  name="dateFilter"
                  label={
                    <Title level={5} style={{ margin: '0' }}>
                      {intl({ id: 'cost.label.filterByDate' })}
                    </Title>
                  }
                  initialValue={dueDate}
                >
                  <Radio.Group
                    buttonStyle="solid"
                    optionType="button"
                    size="large"
                    options={filterByDateOptions}
                  />
                </Form.Item>
              </>
            );
          } else {
            return (
              <Form.Item
                name="workOrderTypes"
                style={{ margin: '4px 0' }}
                label={
                  <Title level={5} style={{ margin: '0' }}>
                    {intl({ id: 'cost.label.budgetType' })}
                  </Title>
                }
                initialValue={[workOrder]}
              >
                <CheckboxGroupButtons options={budgetTypeOptions} />
              </Form.Item>
            );
          }
        }}
      </Form.Item>
    </Form>
  );
}
